export default __webpack_public_path__ + "static/media/06_Kom_Sophienschule.c0fd9823.jpg";